import { RECAPTCHA_TOKEN } from '../../constants';
import { createAction } from 'redux-actions';

export const setRecaptchaToken = createAction(RECAPTCHA_TOKEN, (token) => token);
